<!-- Title -->
<div class="row">
  <div class="col">
    <h5 class="text-uppercase text-muted mb-4">
      {{ title }}
    </h5>
  </div>
</div>

<!-- Input and Selected client details -->
<div class="row">
  <div [class.col-xl-7]="!compact" [class.col-12]="compact">
    <div
      class="form-group fade-in"
      *ngIf="!_documentClientCtrl.controls.name.value"
    >
      <!-- Client search template -->
      <ng-template #clientSearchTemplate let-r="result">
        <span *ngIf="r.id"
          ><b>{{ r.name }}</b></span
        >
        <span *ngIf="!r.id"
          ><b
            ><i class="fas fa-plus-circle fa-xs fa-fw"></i>
            {{ 'Save new' | translate }}: "{{ r.name }}"</b
          ></span
        ><br />
        <span
          >{{ r.address }}<span *ngIf="r.address && r.city">, </span>
          {{ r.city }}</span
        >
      </ng-template>

      <input
        #clientName
        tabindex="0"
        [editable]="true"
        [focusFirst]="false"
        [ngbTypeahead]="clientSearch"
        [resultTemplate]="clientSearchTemplate"
        (selectItem)="onSelectClient($event)"
        placeholder="{{ 'Search by name, address, tax num., ...' | translate }}"
        class="form-control"
        [class.is-invalid]="sent && clientIdCtrl.hasError('required')"
      />

      <span class="loading-feedback" [hidden]="!loading.clients">
        <i class="fa fa-spinner-third fa-spin fa-md"></i>
      </span>

      <div
        class="invalid-feedback animate-show animate-fast"
        *ngIf="sent && clientIdCtrl.hasError('required')"
      >
        {{ 'global.validators.required.error' | translate }}
      </div>
    </div>
  </div>

  <div class="col" *ngIf="!_documentClientCtrl.controls.name.value">
    <button
      tabindex="-1"
      type="button"
      class="btn btn-link"
      (click)="onShowClientAddModal()"
      id="add-client"
    >
      <i class="fe fe-plus-circle fe-md"></i>&nbsp;
      {{ 'Create new Client' | translate }}
    </button>
  </div>

  <div class="w-100" *ngIf="compact"></div>

  <div
    class="col"
    [ngClass]="{ 'col-sm-8 col-md-12 col-lg-10 col-xl-7': !compact }"
  >
    <div
      class="card card-inactive fade-in mb-1"
      *ngIf="_documentClientCtrl.controls.name.value"
      [class.is-invalid]="clientMissingInfo"
      [@slideInOut]
    >
      <div class="card-body">
        <h4 class="mb-2 text-primary">
          <b>{{ _documentClientCtrl.controls.name.value }}</b>
        </h4>
        <p class="mb-2">
          {{ _documentClientCtrl.controls.address.value }}
        </p>
        <p class="mb-2">
          {{ _documentClientCtrl.controls.address2.value }}
        </p>
        <p class="mb-2">
          {{ _documentClientCtrl.controls.zip.value }}
          {{ _documentClientCtrl.controls.city.value }}
        </p>
        <p class="mb-2">
          {{ _documentClientCtrl.controls.country.value }}
        </p>
        <p class="mb-2">
          {{ _documentClientCtrl.controls.taxNumber.value }}
        </p>

        <button
          *ngIf="editable"
          type="button"
          (click)="onUnsetClient()"
          class="btn btn-sm btn-outline-secondary float-right ml-2"
        >
          <i class="fe fe-x mr-1 fe-xs fe-fw"></i>{{ 'Remove' | translate }}
        </button>
        <button
          *ngIf="editable"
          type="button"
          (click)="onShowClientAddModal()"
          class="btn btn-sm btn-outline-secondary float-right"
        >
          <i class="fe fe-edit-2 mr-1 fe-xs fe-fw"></i>{{ 'Edit' | translate }}
        </button>
      </div>
    </div>
    <!-- <div
      class="invalid-feedback animate-show animate-fast"
      [class.d-block]="clientMissingInfo"
      *ngIf="clientMissingInfo"
    >
      {{ 'Missing client information' | translate }}
    </div> -->
  </div>
</div>
